export interface SpriteInfo {
    texture: string,
    frame?: number,
    animationKey?: string,
}

export enum Direction {
    UP = "U",
    DOWN = "D",
    LEFT = "L",
    RIGHT = "R",
}
